<template>
    <section class="theme4-section2">
        <div class="section-wrapper">
            <div class="mask">
                <div class="content">
                    <h3>Lorem ipsum dolor sit amet</h3>
                    <p>Sed interdum vitae libero ac eleifend. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Phasellus at ipsum consectetur, consequat elit eu, semper tellus.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Theme4Section2',
    
}
</script>

<style lang="scss" scoped>
    h3 {
        color: #fff;
    }
    p {
        color: #fff;
    }
    div.section-wrapper {
        width: 100vw;
        height: 700px;
        background-color: $Theme4Secondary;
        background-image: url('https://images.unsplash.com/photo-1569496736555-47c448d556f7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1490&q=80');
        background-size: cover;
        background-position-x: center;
        position: relative;
    }
    div.section-wrapper div.mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba($Theme4Secondary, .7);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    div.section-wrapper div.mask div.content {
        max-width: 60%;
        text-align: center;
    }
</style>
